var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"button button--upload",attrs:{"for":_vm.id}},[_c('div',{staticClass:"input-container"},[_c('input',_vm._g(_vm._b({attrs:{"id":_vm.id,"type":"file"}},'input',_vm.$attrs,false),_vm.$listeners))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }